/**
 * Labstep
 *
 * @module prosemirror/nodes/smart-table
 * @desc SmartTable node
 */

import type { LabstepNode } from 'labstep-web/prosemirror/nodes/types';
import { getAttrsForId } from 'labstep-web/prosemirror/nodes/utils';
import type { Node as ProseMirrorNode } from 'prosemirror-model';

const key = 'smart_table';

export const NodeSmartTable: LabstepNode = {
  key,
  spec: {
    draggable: false,
    attrs: {
      id: { default: null },
    },
    group: 'block',
    marks: '',
    parseDOM: [
      { tag: 'div', getAttrs: getAttrsForId(key) },
      { tag: 'div[type="smart_table"]', getAttrs: () => ({}) },
    ],
    toDOM(node: ProseMirrorNode) {
      const { id } = node.attrs;
      return [
        'div',
        {
          type: key,
          [`data-${key}-id`]: id,
        },
      ];
    },
  },
};
